<template>
  <div id="waiting">
    <div class="waiting_nav">
      <img @click="_return()" src="../../images/lujing.png" alt />
      <h4>已接单</h4>
    </div>
 
    <div id="waiting_list">
      <ul v-if="content_list != ''">
        <li v-for="itme in content_list" :data-id="itme.order_id" @click="details(itme.order_id)" to="/DetailsReceived">
          <img :src="itme.face" alt />
          <div>
            下单时间：{{itme.create_time }}
            <p>{{itme.specification}}</p> 
            <span>总价：￥{{ itme.money }}元</span>
            <span id="last">总数量：{{ itme.count }}</span>
          </div>
        </li>
      </ul>
       
        <div class="more-load" v-if="isMoreLoad">
          <img v-if="loadingImg" src="../../images/lAHPBbCc24iO-9dAQA_64_64.gif" alt="">
          <span>加载更多中..</span>
        </div>
        <div class="more-load" v-if="loadLastText">到底啦〜想不到你看到了这里^_^</div>
      </div>
  </div>
</template>
<script>

//已接单页面

import API from "../../lmj_Api/api";
export default {
  data() {
    return {
      name: "receivedorders",
      content_list: [],
      uid: this.$store.getters.get_user_id,
      isMoreLoad: false,  // 是否显示加载更多
      loadingImg: false,  // 加载更多时显示loading图
      loadLastText: false, // 到底了
      definePageNum: 1,// 默认加载页数
      definePafeSize: 10, // 默认每页数量
      totals: null, // 用来存放总数量

    };
  },
  created() {
    this.get_content();
  },
  mounted() {
    var _this = this;
    // _this.get_content();
    window.addEventListener('scroll', function(){
    var scr = document.documentElement.scrollTop || document.body.scrollTop; // 向上滚动的那一部分高度
    var clientHeight = document.documentElement.clientHeight; // 屏幕高度也就是当前设备静态下你所看到的视觉高度
     var scrHeight = document.documentElement.scrollHeight || document.body.scrollHeight; // 整个网页的实际高度，兼容Pc端
     console.log(scr,clientHeight, scrHeight)
    if(scr + clientHeight + 10 >= scrHeight){
     if(_this.isMoreLoad){ //this.isMoreLoad控制滚动是否加载更多
    	_this.definePageNum = _this.definePageNum + 1; // 加载更多是definePageNum+1
       _this.scrollLoadMore();
     }else{
       return;
     }
   }
 });

  },
  methods: {
    _return() {
      this.$router.go(-1);
    },

     scrollLoadMore(){
  // 防止多次加载
     if(this.loadingImg){
       return;
     }
    this.loadingImg = true;
    this.get_content();
   },

    get_content() {
      let  url = API.waitingOrder;
      var that = this;
      let data = {
            user_id:that.uid,
            type:2,// 1是待接单 2 已接单
             page: that.definePageNum
          }
      that.axios
        .post(url,data)
        .then(function(response) {
          //this指向当前组件实例
          let _data = response.data;
         if(_data.code == 200) {
              that.loadingImg = false;
            if(_data.data.length != 0) {
              _data.data.forEach(element => {
                that.content_list.push(element);
              });
              if(that.content_list.length >= that.definePafeSize) {
               that.isMoreLoad = true;
              }
            } else if (that.content_list.length >= that.definePafeSize) {
              // 数据请求榨干了到底了
              that.isMoreLoad = false;
              that.loadLastText = true;
              window.setTimeout(()=> {
                that.loadLastText = false;
              },2000)
            }
            
          }
          
        })
        .catch(function(response) {
          //出错处理
        });
    },

    //跳转详情 拼接参数id
    details(sole) {
        console.log(parseInt(sole))
         this.$router.push({ name: 'DetailsReceived', params: { id: sole }}) // 跳转 给下一个详细页面传参数 拿不到！！
    }
  }
};
</script>
<style lang="less" scoped>
#waiting {
  div,
  p,
  ul,
  li,
  a,
  h4,
  img {
    padding: 0;
    margin: 0;
  }
  // 导航条
  .waiting_nav {
    position:fixed!important;
    top: 0;
    left: 0;
    z-index: 99;
    background: linear-gradient(90deg, rgba(123, 212, 255, 1) 0%, rgba(92, 186, 255, 1) 100%);
    line-height: 0.88rem;
    height: 0.88rem;
    width: 7.5rem;
    text-align: center;
    position: relative;
    img {
      height: 0.34rem;
      position: absolute;
      left: 0.44rem;
      top: 0.26rem;
    }
    h4 {
      color: white;
      width: 100%;
      font-size: 0.30rem;
      font-family: PingFangSC-Medium, sans-serif;
      font-weight: 400;
    }
  }
  //  导航条end
   // content_list_status
  #waiting_list::-webkit-scrollbar {
     display: none;
  }
  #waiting_list {
    width: 7.5rem;
    // min-height:  calc(~"(100% - 0.88rem)");
    padding-top: 0.88rem;
    text-align: left;
    overflow: hidden;
    overflow-y: scroll;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch!important;

    // ul::-webkit-scrollbar {
    //     display: none;
    // }
    //底部加载 
      .more-load, .more-load {
        background: rgba(0,0,0,.04);
        display: flex;
        justify-content: center;
        padding: 0.1rem;
        font-size: .24rem;
        
        img {
          width: .34rem;
          height: .34rem;
          margin-right: 0.2rem;
        }
      }

    ul {
      // overflow: hidden;
      background-color: red;
      width: 7.5rem;
      height: 100%;
      li {
        width: 7.2rem;
        height: 1.7rem;
        padding: 0.24rem 0 0.26rem 0.3rem;
        border-bottom: 0.5px solid #ccc;
        background: white;
        position: relative;
        img {
          width: 1.7rem;
          height: 1.7rem;
          position: absolute;
          top: 0.2rem;
          left: 0.2rem;
        }
        div {
          height: 1.6rem;
          margin-left: 1.8rem;
          font-size: 0.3rem;
          font-family:PingFangSC-Medium,PingFang SC;
          font-weight:500;
          color:rgba(74,74,74,1);
              p {
            color: rgba(74, 74, 74,1);
          }
          span {
            position:absolute;
            top: 1.5rem;
            color: #ff5d33;
            font-size: 0.3rem;
            font-weight: 500;
          }
        }
        #last {
          color: rgb(74, 74, 74);
          font-size: 0.27rem;
          font-weight: 500;
          top: 1.5rem;
          right: 0.3rem;
          position: absolute;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/sym/receivedorders.vue